import { get } from 'lodash/object';
import { createSelector } from 'reselect';
import {
  appealGradesExamSelectedSelector,
  examListSelector,
  currentExamSelector,
  examsAvailabilitySelector,
  onlineChatIntervalsSelector
} from '../examData/selectors';
import { timeSlotChatTextSelector } from '../timeSlotChat/selectors';
import { giaSelectedSelector } from '../gia/selectors';
import { applicantTypeSelector } from '../applicant/selectors';
import { passportValidationSelector } from '../passport/selectors';
import { passportValidationSelector as passportChildValidationSelector } from '../passportChild/selectors';
import {
  mainDataFullValidationSelector,
  mainDataValuesSelector,
  getUnderFourteenSelector
} from '../mainData/selectors';
import { actRecordValidationSelector } from '../actRecord/selectors';
import { mainDataFullValidationSelector as mainDataChildFullValidationSelector } from '../mainDataChild/selectors';
import { appealAgreementOnSelector } from '../examData/selectors';
import { sendStats, STEP_COMPLETE } from '../../resources/metrics';
import { APPLICANT_TYPES } from '../../constants/applicant';

export const stepSelector = state => state.step;

export const stepIdSelector = createSelector(
  stepSelector,
  subState => subState.id
);

export const completeSTEP1Selector = createSelector(
  giaSelectedSelector,
  appealAgreementOnSelector,
  examsAvailabilitySelector,
  (step1, appealAgreementOn, hasAvailableExams) =>
    step1.valid && appealAgreementOn && hasAvailableExams
);

export const completeSTEPAPPLICANTTYPESelector = createSelector(
  completeSTEP1Selector,
  applicantTypeSelector,
  (step1, applicantType) => step1 && !!applicantType
);

export const completeSTEPAPPLICANTSelector = createSelector(
  completeSTEPAPPLICANTTYPESelector,
  applicantTypeSelector,
  mainDataFullValidationSelector,
  passportValidationSelector,
  (stepApplicantType, applicantType, mainData, passport) => {
    if (applicantType && applicantType === APPLICANT_TYPES.participant) {
      return stepApplicantType;
    }

    return stepApplicantType && mainData.valid && passport.valid;
  }
);

const combinedSelector = createSelector(
  completeSTEPAPPLICANTTYPESelector,
  completeSTEPAPPLICANTSelector,
  applicantTypeSelector,
  mainDataFullValidationSelector,
  (stepApplicantType, stepApplicant, applicantType, mainDataValid) => {
    return { stepApplicantType, stepApplicant, applicantType, mainDataValid };
  }
);

const secondCombinedSelector = createSelector(
  mainDataValuesSelector,
  passportValidationSelector,
  mainDataChildFullValidationSelector,
  passportChildValidationSelector,
  (mainData, passport, mainDataChild, passportChild) => {
    return { mainData, passport, mainDataChild, passportChild };
  }
);

export const completeSTEP2Selector = createSelector(
  combinedSelector,
  secondCombinedSelector,
  actRecordValidationSelector,
  getUnderFourteenSelector,
  (data, data2, actRecord, underFourteen) => {
    const {
      stepApplicantType,
      stepApplicant,
      applicantType,
      mainDataValid
    } = data;
    const { mainData, passport, mainDataChild, passportChild } = data2;
    let complete;

    if (applicantType === APPLICANT_TYPES.participant) {
      complete =
        stepApplicantType &&
        mainDataValid.valid &&
        passport.valid &&
        actRecord.valid &&
        mainData.citizenship &&
        !underFourteen;
    } else {
      complete =
        stepApplicant &&
        mainDataChild.valid &&
        passportChild.valid &&
        actRecord.valid;
    }

    // TODO: вынести сбор статистики из селектора
    if (complete) {
      sendStats(STEP_COMPLETE('Сведения о заявителе'));
    }

    return !!complete;
  }
);

export const completeSTEP3Selector = createSelector(
  completeSTEP2Selector,
  appealGradesExamSelectedSelector,
  (step2, step3) => {
    const complete = step2 && step3;

    // TODO: вынести сбор статистики из селектора
    if (complete) {
      sendStats(STEP_COMPLETE('Предмет'));
    }

    return !!complete;
  }
);

export const completeSTEP4Selector = createSelector(
  completeSTEP3Selector,
  onlineChatIntervalsSelector,
  timeSlotChatTextSelector,
  (step3, onlineChatIntervals, onlineChatSelected) => {
    const complete =
      step3 &&
      onlineChatSelected &&
      onlineChatIntervals.find(item => {
        return item.text === onlineChatSelected;
      });

    // TODO: вынести сбор статистики из селектора
    if (complete) {
      sendStats(STEP_COMPLETE('Выбор предпочтительного времени онлайн-чата'));
    }

    return !!complete;
  }
);

export const showSTEP3Selector = createSelector(
  completeSTEP2Selector,
  examListSelector,
  (step2, examList) => step2 && examList.length > 0
);

export const showSTEP4Selector = createSelector(
  completeSTEP3Selector,
  currentExamSelector,
  (step3, currentExam) => {
    return step3 && currentExam.examApprove;
  }
);

export const showSTEP5Selector = createSelector(
  completeSTEP4Selector,
  currentExamSelector,
  (step4, currentExam) => {
    return step4 && currentExam.examApprove;
  }
);

export const stepConfirmationSelector = createSelector(stepSelector, subState =>
  get(subState, 'confirmation', false)
);

export const stepShowConfirmationSelector = createSelector(
  stepConfirmationSelector,
  completeSTEP4Selector,
  (stepConfirmation, completeStep4) => stepConfirmation && completeStep4
);
